import { Dialog, DialogContent } from '@mui/material';
import { Save } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import ConfirmContent from './ConfirmContent';

interface SaveButtonProps {
  isLoading: boolean;
  isFormUnchanged: boolean;
  isValid: boolean;
  onSubmit: (data: any) => Promise<void>;
}

/**
 * Generic component to display a save button with a confirmation dialog
 * @param props Form flags to enable/disable the button and functions to handle the submit of the form
 * @returns
 */
const SaveButtonComponent = (props: SaveButtonProps) => {
  const { t } = useTranslation();
  const { isLoading, isFormUnchanged, isValid, onSubmit } = props;
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <LoadingButton
        loading={isLoading}
        disabled={isFormUnchanged || !isValid}
        variant="contained"
        color="primary"
        startIcon={<Save />}
        onClick={() => setOpen(true)}
      >
        {t('save')}
      </LoadingButton>
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '0.8rem',
          },
        }}
      >
        <DialogContent>
          <ConfirmContent
            onSaveClick={(event) => {
              onSubmit(event);
              setOpen(false);
            }}
            onDiscardClick={handleClose}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SaveButtonComponent;
